import classNames from 'classnames';
import { ReactComponent as RepeatIcon } from '@Icons/additional/repeat.svg';

import styles from './material-tab-item.module.css';

interface MaterialTabItemProps {
  index: number;
  activityCode: string | number;
  resourceCode: string | number;
  materialCode: string | number;
  plantCode: string | number;
  ledgerCode: string | number;
  unit: string | number;
  qty: string | number;
  remarks: string;
  repeatItem: boolean;
}

const MaterialTabItem: React.FC<MaterialTabItemProps> = ({
  activityCode,
  materialCode,
  ledgerCode,
  plantCode,
  qty,
  remarks,
  resourceCode,
  unit,
  index,
  repeatItem = false,
}) => {
  return (
    <div className={classNames(styles.container, repeatItem && styles.active)}>
      <div className={styles.header}>
        <div className={styles.caption}>Material No.{index}</div>
        {repeatItem && (
          <div className={styles.actions}>
            <div className={styles.state}>Template</div>
          </div>
        )}
      </div>
      <div className={styles.content}>
        {Boolean(activityCode) && (
          <div className={styles.description}>
            <span>Activity Code</span>
            <div>
              {repeatItem && (
                <span className={styles.repeatIcon}>
                  <RepeatIcon />
                </span>
              )}
              <span>{activityCode}</span>
            </div>
          </div>
        )}
        {Boolean(resourceCode) && (
          <div className={styles.description}>
            <span>Resource Code</span>
            <span>{resourceCode}</span>
          </div>
        )}
        {Boolean(materialCode) && (
          <div className={styles.description}>
            <span>Material Code</span>
            <span>{materialCode}</span>
          </div>
        )}
        {Boolean(plantCode) && (
          <div className={styles.description}>
            <span>Plant Code</span>
            <span>{plantCode}</span>
          </div>
        )}
        {Boolean(ledgerCode) && (
          <div className={styles.description}>
            <span>Ledger Code</span>
            <span>{ledgerCode}</span>
          </div>
        )}
        <div className={styles.description}>
          <span>Unit</span>
          <span>{unit}</span>
        </div>
        <div className={styles.description}>
          <span>Qty.</span>
          <span>{qty}</span>
        </div>
        <div className={styles.description}>
          <span>Remarks</span>
          <span>{remarks}</span>
        </div>
      </div>
    </div>
  );
};

export default MaterialTabItem;
